// Module
var code = "<span class=\"badge badge-discussion\" ng-class=\"{ 'badge-all-read' : !unread, 'badge-unread' : unread }\"> {{total}} </span>";
// Exports
var _module_exports =code;;
var path = '/views/common/discussion_indicator.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;